module.exports = __webpack_public_path__ + "img/logo-dark.51318612.png";